import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CompanyMaintenanceComponent } from './company-maintenance.component';

const routes: Routes = [
  {
    path:'',
    component: CompanyMaintenanceComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CompanyMaintenanceRoutingModule { }
